'use strict';

angular.module('personModule', [
    'gov.filters',
    'gov.services',
    'gov.directives'
]);